import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  books: {}, // { [bookId]: bookData }
  localizedBooks: {}, // { [bookId:language]: localized book response }
  bookLanguages: {}, // Language of the cached, localized book response.
  chapters: {}, // { [chapterId]: chapterTitle }
};

const bookDataSlice = createSlice({
  name: 'bookData',
  initialState,
  reducers: {
    setBook(state, action) {
      const { bookId, bookData, language } = action.payload;
      state.books[bookId] = bookData;
      state.bookLanguages[bookId] = language;
      if (language) state.localizedBooks[`${bookId}:${language}`] = bookData;
    },
    setChapterTitle(state, action) {
      const { chapterId, title } = action.payload;
      state.chapters[chapterId] = title;
    },
    setChapterTitlesBulk(state, action) {
      const chapters = action.payload; // объект { chapterId: title }
      Object.entries(chapters).forEach(([chapterId, title]) => {
        state.chapters[chapterId] = title;
      });
    },
  },
});

export const { setBook, setChapterTitle, setChapterTitlesBulk } = bookDataSlice.actions;
export default bookDataSlice.reducer;
